import {EventEmitter, Injectable} from '@angular/core';
import {AccessPermissionsService} from "./access-permissions.service";
import {MenuFactory} from "../designpattern/strategy/menu/MenuFactory";

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private activeMenuName: string = '';
  private IsLoadingInProgress = false;
  private IsSavingInProgress = false;
  private IsSearchInProgress = false;

  loadingStatusChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  savingStatusChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  searchStatusChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  private setLoadingStatus(status: boolean) {
    this.IsLoadingInProgress = status;
    this.loadingStatusChanged.emit(this.IsLoadingInProgress);
  }

  private setSavingStatus(status: boolean) {
    this.IsSavingInProgress = status;
    this.savingStatusChanged.emit(this.IsSavingInProgress);
  }

  private setSearchStatus(status: boolean) {
    this.IsSearchInProgress = status;
    this.searchStatusChanged.emit(this.IsSearchInProgress);
  }

  constructor(
    private accessPermissionService: AccessPermissionsService,
    private menuFactory: MenuFactory) {
  }

  public ShowLoadingInProgressScreen() {
    this.setLoadingStatus(true);
  }

  public ShowSavingInProgressScreen() {
    this.setSavingStatus(true);
  }

  public ShowSearchInProgressScreen() {
    this.setSearchStatus(true);
  }

  public StopLoadingInProgressScreen() {
    this.setLoadingStatus(false);
  }

  public StopSavingInProgressScreen() {
    this.setSavingStatus(false);
  }

  public StopSearchInProgressScreen() {
    this.setSearchStatus(false);
  }

  public GetIsLoadingInProgressScreen() {
    return this.IsLoadingInProgress;
  }

  public GetIsSavingInProgressScreen() {
    return this.IsSavingInProgress;
  }

  public GetIsSearchInProgressScreen() {
    return this.IsSearchInProgress;
  }

  public SetActiveMenuName(name: string): void {
    this.activeMenuName = name;
  }

  public GetActiveMenuName(): string {
    return this.activeMenuName;
  }

  public GetMenuTitle (name: string): string {
    const strategy = this.menuFactory.createStrategy(name.toLowerCase());
    if(strategy == null) {
      return '';
    }
    return strategy.getMenuTitle();
  }

  public GetMenuPageTitle (name: string): string {
    const strategy = this.menuFactory.createStrategy(name.toLowerCase());
    if(strategy == null) {
      return '';
    }
    return strategy.getPageTitle();
  }

  public GetMenuPageComponent (name: string): string {
    const strategy = this.menuFactory.createStrategy(name.toLowerCase());
    if(strategy == null) {
      return '';
    }
    return strategy.getPageComponent();
  }

  public IsUserEnabled(name: string): boolean {

    // return true;
    // bypass all checks

    let elements = this.accessPermissionService.GetAccessPermissions();
    let foundElement = elements.find((element) => element.functionName.toLowerCase() === name.toLowerCase());
    return foundElement ? foundElement.read : false;
  }

}
